import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  user: {
    error: {
      isError: false,
      message: "",
    },
    userDetails: null,
    planDetails: null,
    selectedWorkspace: null,
    allWorkspaces: [],
  },
  isPrivilegeUser: false,
  triggerUiRerender: false,
  proPlans: null,
  userPaymentHistory: null,
};

export const loginSlice = createSlice({
  name: "loginUserData",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setUserDetails: (state, action) => {
      state.user.userDetails = action.payload;
      state.user.error = {
        isError: false,
        message: "",
      };
    },
    setSelectedWorkspace: (state, action) => {
      state.user.selectedWorkspace = action.payload
    },
    setAllWorkspaces: (state, action) => {
      state.user.allWorkspaces = action.payload
    },
    setPlanDetails: (state, action) => {
      state.user.planDetails = action.payload
    },
    setUserDetailsError: (state, action) => {
      state.user.userDetails = null;
      state.user.planDetails = null;
      state.user.error = action.payload;
    },
    setTriggerUiRender: (state, action) => {
      state.triggerUiRerender = action.payload;
    },
    setPrivilegeUserFlag: (state, action) => {
      state.isPrivilegeUser = action.payload;
    },
    setProPlans: (state, action) => {
      state.proPlans = action.payload
    },
    getUserPaymentHistory: (state, action) => {
      state.userPaymentHistory = action.payload
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLoading,
  setUserDetails,
  setPlanDetails,
  setUserDetailsError,
  setTriggerUiRender,
  setPrivilegeUserFlag,
  getUserPaymentHistory,
  setSelectedWorkspace,
  setAllWorkspaces,
} = loginSlice.actions;

export default loginSlice.reducer;

export const loginItemsSelector = (state) => state.loginUserData;
